__turbopack_context__.v({
  "defaultPadding": "signup-module-sass-module__PI69oq__defaultPadding",
  "noPadding": "signup-module-sass-module__PI69oq__noPadding",
  "signup": "signup-module-sass-module__PI69oq__signup",
});
